{
  "COMMON": {
    "SAVE": "Save",
    "EDIT": "Edit",
    "CANCEL": "Cancel",
    "CLOSE": "Close",
    "DELETE": "Delete"
  },
  "AI_KNOWLEDGE_BASE": "AI knowledge base",
  "MANAGE_KNOWLEDGE": "Manage knowledge",
  "MANAGE_KNOWLEDGE_DESCRIPTION": "Manage a central library of knowledge to utilize across AI features",
  "REFRESH_OPTIONS": "Refresh options",
  "CHOOSE_KNOWLEDGE_SOURCES": "Choose the knowledge sources that the Automated Assistant will reference when responding to inquiries",
  "KNOWLEDGE_SOURCES": "Knowledge sources",
  "ADD_KNOWLEDGE": "Add knowledge",
  "SELECT_KNOWLEDGE": "Select knowledge",
  "APPLICATION_SETTINGS": "Settings",
  "APPS_WARNING": "This knowledge is currently being used by the following:",
  "NO_APPS": "This knowledge is not currently being used.",
  "NO_MATCHING_KNOWLEDGE_SOURCES": "No knowledge available",
  "EDIT_KNOWLEDGE": {
    "TITLE": "Custom knowledge",
    "NAME": "Name",
    "CONTENT": "Content",
    "CONTENT_HINT": "Enter any text content related to your business such as FAQs or information snippets.\nThis will enable AI features to accurately answer questions and create content about your business."
  },
  "DELETE_KNOWLEDGE": {
    "TITLE": "Delete custom knowledge?"
  },
  "BUSINESS_PROFILE": {
    "BUSINESS_PROFILE": "Business Profile",
    "ALLOW_ACCESS": "Allow access to your business profile",
    "DESCRIPTION": "Answer questions about your business contact information, hours, products and services you offer.",
    "MANAGE_BUSINESS_PROFILE": "Manage business profile",
    "LEARN_MORE": {
      "TITLE": "Learn more",
      "WHAT_INFORMATION_QUESTION": "What information is made available to your Automated Assistant?",
      "WHAT_INFORMATION": "These fields are shared from your business profile:",
      "BUSINESS_NAME": "Business name",
      "ADDRESS_SERVICE_AREAS": "Address and/or service areas",
      "WEBSITE": "Website",
      "PHONE_NUMBER": "Phone number",
      "CATEGORIES": "Categories",
      "HOURS": "Hours",
      "SERVICES_OFFERED": "Services offered",
      "SHORT_DESCRIPTION": "Short description",
      "LONG_DESCRIPTION": "Long description",
      "SOCIAL_MEDIA_URLS": "Social media URLs",
      "BOOKING_URL": "Booking URL"
    }
  }
}
